import { render, staticRenderFns } from "./base-input.vue?vue&type=template&id=29c1ba44&scoped=true&"
import script from "./base-input.vue?vue&type=script&lang=js&"
export * from "./base-input.vue?vue&type=script&lang=js&"
import style0 from "./base-input.vue?vue&type=style&index=0&id=29c1ba44&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c1ba44",
  null
  
)

export default component.exports